
  if (!customElements.get('wholesale-order-rep')) {
    customElements.define('wholesale-order-rep', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('change', () => this.save(), { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async save() {
        const select = this.querySelector('select');
        const value = select.value;
        const status = this.querySelector('.hs-rep-status');
        const summary = this.closest('.cart-drawer__summary, .cart-page__summary') || this.parentElement;
        const checkout = summary.querySelector('[name="checkout"]');
        const accelerated = summary.querySelector('.additional-checkout-buttons');
        this.pendingCount = (this.pendingCount || 0) + 1;
        if (checkout) checkout.disabled = true;
        if (accelerated) { accelerated.inert = true; accelerated.style.pointerEvents = 'none'; }
        status.textContent = '';
        try {
          const saveRequest = () => fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Sales representative': value } })
          });
          const request = (this.constructor.queue || Promise.resolve()).catch(() => {}).then(saveRequest);
          this.constructor.queue = request.then(response => response.clone().json());
          const response = await request;
          if (!response.ok) throw new Error('Cart update failed');
          const cart = await response.json();
          if (cart.attributes['Sales representative'] !== value) throw new Error('Cart attribute missing');
          if (this.pendingCount === 1) document.querySelectorAll('wholesale-order-rep select').forEach(other => { other.value = value; });
          status.textContent = this.dataset.saved;
        } catch {
          status.textContent = this.dataset.error;
        } finally {
          this.pendingCount -= 1;
          if (checkout && this.pendingCount === 0) checkout.disabled = false;
          if (accelerated && this.pendingCount === 0) { accelerated.inert = false; accelerated.style.pointerEvents = ''; }
        }
      }
    });
  }
